// Faithful port of eb-ui `packages/eds/eds-share-box/src/FacebookShare.jsx`.
import React from 'react';
import { formatUrl } from 'url-lib';
import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { LogoFacebook } from '@eventbrite/legacy-eds.iconography';
import { gettext } from '../../i18n/gettext';
import { FACEBOOK_AFFILIATED_CODE } from './constants';
import { openUrl } from './utils';
import type { BaseShareProps, FacebookOptions, UtmOptions } from './types';

const FACEBOOK_URL = 'https://www.facebook.com/dialog/share';

const _getEventUrl = (
    eventUrl: string,
    affiliateChannel: string | undefined,
    utmOptions: UtmOptions | undefined,
) =>
    formatUrl(eventUrl, {
        aff:
            (affiliateChannel && FACEBOOK_AFFILIATED_CODE[affiliateChannel]) ||
            FACEBOOK_AFFILIATED_CODE['default'],
        ...utmOptions,
    });

export interface FacebookShareProps extends BaseShareProps {
    facebookOptions: FacebookOptions;
}

export default class FacebookShare extends React.Component<FacebookShareProps> {
    _handleButtonClick() {
        const {
            affiliateChannel,
            eventUrl,
            facebookOptions: { appId, locale },
            onClick,
            utmOptions,
        } = this.props;
        const url = formatUrl(FACEBOOK_URL, {
            locale,
            app_id: appId,
            display: 'popup',
            href: _getEventUrl(eventUrl, affiliateChannel, utmOptions),
        });

        if (onClick) {
            onClick();
        }

        openUrl(url);
    }

    render() {
        return (
            <span
                className="eds-l-pad-right-1"
                data-spec="facebook-share-box-container"
                data-heap-id={this.props.dataHeapId}
                data-share-method={this.props.shareMethod}
                data-page-area={this.props.dataPageArea}
                data-event-id={this.props.eventId}
            >
                <IconButton
                    iconType={<LogoFacebook />}
                    title={gettext('Share on Facebook')}
                    onClick={this._handleButtonClick.bind(this)}
                />
            </span>
        );
    }
}
